import { IRoute } from "./models/route";
import PreviewView from "./view/Preview";
import NotFoundView from "./view/404";

const routes:IRoute[] = [
  {
    path: '/content/:id',
    title: 'Preview',
    isUsedInMenu: false,
    mode: 'strict',
    component: PreviewView
  },
  {
    path: '/not_found',
    mode: 'exact',
    title: 'Not found',
    isUsedInMenu: false,
    component: NotFoundView
  }

]
export default routes
